module.exports = __webpack_public_path__ + "img/login-bg.e1f058be.png";